import {
  ArrowBackOutlined as ArrowBackOutlinedIcon,
  AutoFixHighOutlined as AutoFixHighOutlinedIcon,
  MenuBookOutlined as MenuBookOutlinedIcon
} from '@mui/icons-material'
import ResizableModal from '../../../../../ui/ResizableModal'

const MODAL_TITLES = {
  build: {
    icon: AutoFixHighOutlinedIcon,
    title: 'Construir receta',
    description: 'Crea o versiona una receta dentro de un modal, sin mezclarla con la tabla principal.'
  },
  review: {
    icon: MenuBookOutlinedIcon,
    title: 'Revisar receta',
    description: 'Consulta una receta y desde aquí decide si quieres editarla o crear una nueva versión.'
  }
}

const RecipeEditorModal = ({ open, view, onClose, children }) => {
  const modalMeta = MODAL_TITLES[view] || MODAL_TITLES.build
  const IconComponent = modalMeta.icon

  return (
    <ResizableModal
      open={open}
      onClose={onClose}
      width={1240}
      height={860}
      minWidth={980}
      minHeight={680}
      size='large'
    >
      <div className='space-y-4'>
        <div className='flex flex-col gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 md:flex-row md:items-center md:justify-between'>
          <div className='flex items-start gap-3'>
            <div className='flex h-10 w-10 items-center justify-center rounded-xl border border-accent2/20 bg-accent2/[0.10] text-accent2'>
              <IconComponent style={{ fontSize: '1rem' }} />
            </div>
            <div>
              <p className='text-sm font-semibold text-slate-900'>{modalMeta.title}</p>
              <p className='mt-1 text-sm text-slate-600'>{modalMeta.description}</p>
            </div>
          </div>

          <button
            type='button'
            onClick={onClose}
            className='inline-flex items-center justify-center gap-1.5 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:border-slate-400 hover:bg-slate-50'
          >
            <ArrowBackOutlinedIcon style={{ fontSize: '1rem' }} />
            Volver a la tabla
          </button>
        </div>

        {children}
      </div>
    </ResizableModal>
  )
}

export default RecipeEditorModal
